import { useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Trophy } from "lucide-react";
import { toast } from "sonner";

export default function LeaderboardOptIn({ leaderboard, onUpdate }) {
  const [loading, setLoading] = useState(false);

  const toggle = async (checked) => {
    setLoading(true);
    try {
      const { data } = await api.patch("/badges/leaderboard/opt-in", { opt_in: checked });
      onUpdate?.(data);
      toast.success(checked ? "Classement activé" : "Classement désactivé");
    } catch {
      toast.error("Erreur lors de la mise à jour");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="border-amber-100 bg-amber-50/40" data-testid="leaderboard-opt-in">
      <CardContent className="p-5 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center">
            <Trophy className="w-5 h-5 text-amber-700" />
          </div>
          <div>
            <p className="font-semibold text-slate-900">Classement privé</p>
            <p className="text-sm text-slate-500 max-w-md">
              Compare ton activité mensuelle avec les autres coachs (anonyme). Aucun nom n'est affiché publiquement.
            </p>
            {leaderboard?.opt_in && leaderboard?.label && (
              <p className="text-sm font-medium text-amber-700 mt-2">{leaderboard.label}</p>
            )}
            {leaderboard?.opt_in && !leaderboard?.label && leaderboard?.score != null && (
              <p className="text-xs text-slate-400 mt-2">Score activité ce mois : {leaderboard.score}</p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500">Participer</span>
          <Switch checked={!!leaderboard?.opt_in} disabled={loading} onCheckedChange={toggle} />
        </div>
      </CardContent>
    </Card>
  );
}